export const getFallbackURL = () => {
  const activeOrgId = window.localStorage.getItem('active-org-id');

  if (!activeOrgId) {
    return import.meta.env.VITE_LANDING_HOME_URL || '/';
  }

  return `/${activeOrgId}/auth/sign-in`;
};

export const getFeatureFromPath = (
  pathname: string
): 'aimei' | 'library' | 'financials' | 'territories' | null => {
  if (pathname.includes('/ask-aimei')) return 'aimei';
  if (pathname.includes('/library')) return 'library';
  if (pathname.includes('/financial-overview')) return 'financials';
  if (pathname.includes('/territories')) return 'territories';
  return null;
};
